module.exports = __webpack_public_path__ + "static/img/user_active.f6d8d9b9.png";